<template>
  <div class="do-plan">
    <table class="d-table d-table__stue">
      <thead>
      <tr>
        <th colspan="3">
          <div class="do-container">
            <div class="do-container__left">
              <DDropdown class="title--grey">
                <ul slot="list">
                  <li @click="createCalendars('kindergarten')">
                    Opret stuer
                  </li>
                  <li @click="setIsCreateOpeningHours(true)">
                    Åbningstider
                  </li>
                </ul>
              </DDropdown>
              Uge {{ currentWeek }}
              <DutyScheduleNav
                @today="$emit('today')"
                @next="$emit('next')"
                @prev="$emit('prev')">
              </DutyScheduleNav>
              <CopyMultipleCalendarsCopy
                :initCopyDate="date"
                @submit="copyCals($event)">
                <span slot="copy-button-title">Kopier</span>
              </CopyMultipleCalendarsCopy>
            </div>
            <div class="do-spinner" v-if="isEventsLoading"></div>
          </div>
        </th>
        <th v-for="day in days" :key="day.dateFormatted">{{ day.dateFormatted }}</th>
      </tr>
      </thead>
      <DutyScheduleCalendar v-for="calendar in calendars"
                            :calendar="calendar"
                            :date="date"
                            :days="days"
                            :events="events"
                            :usersCalIdsHash="usersCalIdsHash"
                            :eventsInHash="eventsInHash"
                            :theCreateEventObj="theCreateEventObj"
                            :userNorms="userNorms"
                            :theNewlyCreatedSubject="theNewlyCreatedSubject"
                            :openingHours="openingHours"
                            @createSubject="$emit('createSubject', $event)"
                            @createEvent="$emit('createEvent', $event)"
                            @editEvent="$emit('editEvent', $event)">
      </DutyScheduleCalendar>
    </table>
  </div>
</template>

<script>
import moment from 'moment'
import DutyScheduleCalendar from './DutySchedulePlanCalendar.vue'
import CopyMultipleCalendarsCopy from '../CopyCalendar/CopyMultipleCalendarsCopy.vue'
import docendo from '../../docendo'
import eventbus from '../../eventbus'
import DDropdown from '../common/DDropdown.vue'
import DutyScheduleNav from './DutyScheduleNav.vue'
import BottomNav from './BottomNav.vue'

export default {
  components: {BottomNav, DutyScheduleNav, DDropdown, CopyMultipleCalendarsCopy, DutyScheduleCalendar},
  props: {
    date: {
      default: new Date()
    },
    isEventsLoading: {
      type: Boolean,
      default: false
    },
    events: {
      type: Array,
      default: []
    },
    calendars: {
      type: Array,
      default: []
    },
    usersCalIdsHash: {
      default: {}
    },
    eventsInHash: {
      default: {}
    },
    theCreateEventObj: {
      type: Object,
      default: null
    },
    userNorms: {
      type: Array,
      default: []
    },
    theNewlyCreatedSubject: {
      type: Object,
      default: null
    },
    schoolSettings: {
      type: Object,
      default: null
    },
    isCreateOpeningHours: {
      type: Boolean,
      default: false
    },
    openingHours: {
      default: null
    }
  },
  computed: {
    currentWeek () {
      return moment(this.date).isoWeek()
    },
    days () {
      return this.createDates()
    }
  },
  methods: {
    setIsCreateOpeningHours (bool) {
      this.$emit('setIsCreateOpeningHours', bool)
    },
    createCalendars (calendarType) {
      eventbus.createCalendarsType = calendarType
    },
    createDates () {
      moment.locale('da-DK')
      const days = []
      for (let i = 1; i <= 5; i++) {
        const date = moment(this.date).isoWeekday(i)
        days.push({
          dateId: date.format('YYYY-MM-DD'),
          date, // Keep the moment object for flexibility
          dateFormatted: date.format('dddd DD. MMM')
        })
      }
      return days
    },
    copyCals (objWeeks) {
      const selectedCalIds = this.calendars.map(calendar => calendar.id)
      const copyDate = objWeeks.copyDate
      const selectedWeeks = objWeeks.selectedWeeks
      const isDeleteEvents = objWeeks.isDeleteEvents
      docendo.calendarCopyWeeks(selectedCalIds, copyDate, selectedWeeks, isDeleteEvents, [], ['absence', 'presence'], data => {
        eventbus.toast = {text: 'Kopierer kalendere', success: true}
      })
    }
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-table {
  width: 100%;
  border-collapse: collapse;
  border: 1px solid #e2e8f0;
  border-collapse: collapse;
  background-color: #ffffff;
  width: 100%;
}

.d-table.d-table__stue thead th:first-child,
.d-table.d-table__stue tbody td:first-child {
  max-width: 120px;
  text-align: left;
}

.d-table.d-table__stue thead th:not(:first-child),
.d-table.d-table__stue tbody td:not(:first-child) {
  text-align: center;
}

.d-table.d-table__stue tbody tr.stue-header {
  background: var(--doGrey) !important;
  border: 1px solid var(--doBorder);
  font-size: 1rem;
  font-weight: bold;
}

.d-table tr.stue-header td {
  padding: 4px 8px;
}

.d-table.d-table__stue tr {
  border-bottom: 1px solid var(--doBorder);
}

.d-table.d-table__stue tr td {
  border-right: 1px solid var(--doBorder);
  text-align: center;
  vertical-align: baseline;
}

.d-table.d-table__stue tr td:first-child {
  text-align: left;
}

.d-table > thead > tr > th,
.d-table > tfoot > tr > td {
  padding: 5px;
}


.d-table > thead > tr > th:first-child {
  padding-left: 0;
}

.d-table > thead > tr:first-child,
.d-table > tfoot > tr:first-child {
  text-transform: capitalize;
}

.d-table tr th, .d-table > tfoot tr td {
  padding: 4px 8px;
}

.d-table > tfoot tr td {
  color: #8898aa;
}

.d-table > tfoot tr td.th-sorter--active {
  color: var(--dark-blue);
}

.d-table tr td {
  padding: 2px 8px 4px;
}

.do-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.do-container__left {
  display: flex;
  align-items: center;
  gap: 1rem
}
</style>



// WEBPACK FOOTER //
// DutySchedulePlan.vue?c8f501c0